import React, { useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  Dashboard,
  HealthAndSafety,
  Assignment,
  ReportProblem,
  FactCheck,
  Inventory,
  Assessment,
  MenuBook,
  Favorite,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import PageWithHeader from "../common/PageWithHeader";
import { SheqDashboard } from "./sheq/SheqDashboard";
import { SheqPPERegister } from "./sheq/SheqPPERegister";
import { SheqIncidents } from "./sheq/SheqIncidents";
import { SheqInspections } from "./sheq/SheqInspections";
import { SheqCatalogue } from "./sheq/SheqCatalogue";
import { SheqReports } from "./sheq/SheqReports";
import { SheqSOP } from "./sheq/SheqSOP";
import { SheqHealth } from "./sheq/SheqHealth";

const COMS_NAVY = "#123456";

const TABS = [
  { label: "Dashboard", icon: <Dashboard sx={{ fontSize: 18 }} /> },
  { label: "PPE Register", icon: <Assignment sx={{ fontSize: 18 }} /> },
  { label: "Incidents", icon: <ReportProblem sx={{ fontSize: 18 }} /> },
  { label: "Inspections", icon: <FactCheck sx={{ fontSize: 18 }} /> },
  { label: "Health", icon: <Favorite sx={{ fontSize: 18 }} /> },
  { label: "SOPs", icon: <MenuBook sx={{ fontSize: 18 }} /> },
  { label: "Catalogue", icon: <Inventory sx={{ fontSize: 18 }} /> },
  { label: "Reports", icon: <Assessment sx={{ fontSize: 18 }} /> },
];

const SheqHome: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  return (
    <PageWithHeader>
      {/* Header */}
      <Box sx={{ bgcolor: COMS_NAVY, color: "#fff", px: 5, py: 3 }}>
        <Typography
          variant="body2"
          sx={{ color: "rgba(255,255,255,0.6)", cursor: "pointer", mb: 0.5 }}
          onClick={() => navigate("/coms")}
        >
          ← COMS
        </Typography>
        <Box display="flex" alignItems="center" gap={2} mt={1}>
          <HealthAndSafety sx={{ fontSize: 36 }} />
          <Box>
            <Typography variant="h1" sx={{ color: "#fff", fontWeight: 700 }}>
              SHEQ
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)" }}>
              Safety, Health, Environment &amp; Quality — PPE register,
              incidents, inspections &amp; toolbox talks.
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Navigation tabs */}
      <Box sx={{ borderBottom: "1px solid #e0e0e0", bgcolor: "#fff", px: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          textColor="primary"
          indicatorColor="primary"
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 500,
              fontSize: 14,
              minHeight: 48,
            },
          }}
        >
          {TABS.map((t, i) => (
            <Tab key={i} label={t.label} icon={t.icon} iconPosition="start" />
          ))}
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box px={5} py={4}>
        {tab === 0 && <SheqDashboard />}
        {tab === 1 && <SheqPPERegister />}
        {tab === 2 && <SheqIncidents />}
        {tab === 3 && <SheqInspections />}
        {tab === 4 && <SheqHealth />}
        {tab === 5 && <SheqSOP />}
        {tab === 6 && <SheqCatalogue />}
        {tab === 7 && <SheqReports />}
      </Box>
    </PageWithHeader>
  );
};

export default SheqHome;
